/* @ngInject */
const auth = (
  $window,
  $http,
  storageHandler
) => {
  const self = {}

  self.parseJwt = (_token = '') => {
    const base64Url = (_token.split('.') || ['', ''])[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse($window.atob(base64))
  }

  self.isLog = () => {
    const token = self.getToken()
    if (token === undefined || token === '') {
      return false
    }
    const tokendata = self.parseJwt(token)
    if (tokendata === undefined) {
      return false
    }

    const now = Math.round((new Date()).getTime() / 1000)

    if (tokendata.exp === undefined) {
      return false
    }
    if (tokendata.exp < now) {
      return false
    }

    return true
  }

  self.isAdmin = () => {
    const token = self.getToken()
    if (token === undefined || token === '') {
      return false
    }

    const tokendata = self.parseJwt(token)
    if (tokendata === undefined) {
      return false
    }

    return tokendata.user.admin
  }

  self.logout = () => {
    self.deleteToken()
    self.deleteUsername()
    $http.defaults.headers.common.Authorization = null
  }

  self.saveToken = (_token) => {
    storageHandler.save('jwtToken', _token)
    // $window.localStorage['jwtToken'] = _token
  }

  self.deleteToken = () => {
    storageHandler.save('jwtToken', '')
    // $window.localStorage['jwtToken'] = ''
  }

  self.getToken = () => {
    return storageHandler.get('jwtToken') || ''
    // return $window.localStorage['jwtToken']
  }

  self.saveUsername = (_username) => {
    storageHandler.save('username', _username)
    // $window.localStorage['username'] = _username
  }

  self.deleteUsername = () => {
    storageHandler.save('username', '')
    // $window.localStorage['username'] = ''
  }

  self.getUsername = () => {
    return storageHandler.get('username') || ''
    // return $window.localStorage['username']
  }

  self.getUid = () => {
    return $window.localStorage['id']
  }

  self.saveUid = (_id) => {
    $window.localStorage['id'] = _id
  }

  return self
}

export default auth



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/auth.service.js